import { useContext, useCallback } from 'react';

import { ImportStateContext } from '../components/ImportStateContextProvider.tsx';
import { isDocWithWrongType, DocExceededSizeLimit } from '../utils/fileValidation.ts';
import { ImportModalTypes } from '../components/Modals/ImportModalTypes.ts';
import { ProgressStatus } from '../components/Modals/ProgressModal/progress-types.ts';
import { FILE_UPLOAD_LIMIT_BULK } from '../config/fileUploadLimit.ts';

import { ErrorRoles, DocErrors } from './useUploadReducer.ts';

export const useValidateBulkDocuments = (): ((documents: any) => any) => {
	const {
		updateModalData,
		docActions: { uploadDocFailure },
	} = useContext(ImportStateContext);

	return useCallback(
		(documents: any) => {
			const filtered = documents.filter((doc: File | null) => doc);
			if (!filtered.length) {
				updateModalData(ImportModalTypes.PROGRESS, {
					status: ProgressStatus.ERROR,
				});
				return [];
			}

			return filtered
				.map((doc: File) => {
					if (isDocWithWrongType(doc.type)) {
						uploadDocFailure(doc.name, {
							type: DocErrors.TYPE_ERROR,
							role: ErrorRoles.ERROR,
						});
						return null;
					}
					if (DocExceededSizeLimit(doc.size, FILE_UPLOAD_LIMIT_BULK)) {
						uploadDocFailure(doc.name, {
							type: DocErrors.SIZE_LOCAL_ERROR,
							role: ErrorRoles.ERROR,
						});
						return null;
					}
					return doc;
				})
				.filter((doc: File | null) => doc);
		},
		[updateModalData, uploadDocFailure],
	);
};
